import axios from "axios";

export default class axiosClient {
  async depositWithBankCard(params) {
    return await axios.post("/api/pays/create", params);
  }
}
